import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import React from "react";

/**
 * A modal representing the send of two steps in the Forgot Password process.
 * It consists of a form that collects the one-time token sent by email,
 * the user's chosen new password, and a matching confirmation password.
 *
 * Props:
 *  callback - A function that will handle the form submission. The single
 *  argument for callback will be the form data object:
 *  {token, password, confirmPassword}. The callback
 *  is expected to reset the user's password and send them to the login modal.
 */
export default function ForgotPasswordModal1({ callback, email, openLogin }) {
  return (
    <Modal
      title="Forgot Password - Step 2/2"
      className="login-modal"
      visible={true}
      closable={false}
      footer={null}
    >
      <p>It may take a minute or two for you to receive this code in your inbox.</p>
      <Form
        initialValues={{
          remember: true,
        }}
        key="login-form"
        onFinish={callback}
      >
        <Form.Item
          name="token"
          rules={[
            {
              required: true,
              message: "Paste in the code from your Email!",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder={`One-time code sent to ${email}`}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your Password!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if(!value.length){
                  return Promise.resolve();
                }
                if (value.length < 8) {
                  return Promise.reject("Password must be at least 8 characters in length");
                }
                if (!/[a-zA-Z]/.test(value) || !/[0-9]/.test(value) || !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)) {
                  return Promise.reject("Password must be a mix of letters, numbers & symbols");
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="New password"
          />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: "Please confirm your Password!",
            },
            // The confirmPassword value must match the password
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  "The two passwords that you entered do not match!"
                );
              },
            }),
          ]}
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Confirm password"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Set new password
          </Button>
          <Button type="link" onClick={openLogin}>
            Return to Login
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
